// O endereco para onde o indice pula. Mora aqui, e nao dentro de cada
// renderizador, porque a tela do app e a pagina solta precisam calcular o
// MESMO endereco: se as duas divergirem, o indice de uma delas leva a lugar
// nenhum -- e falha de ancora e silenciosa, so aparece no dedo de quem toca.
export function ancoraDaSecao(titulo: string): string {
  return titulo
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}
